module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('construction')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cccf4b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Current.vue
// module id = 72
// module chunks = 0